/**
 *
 * This component's job is simply to listen for changes in our booking data,
 * and then fire off a validation call.
 *
 * It is a component rather than a hook, so that we can avoid forcing another
 * component to re-render.
 */
import { useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";

import { useValidateBookingRules } from "@whoosh/features/src/Restrictions";

import { validateRestrictionsInputAtom } from "../../atoms/selectors/validateRestrictionsInputAtom/validateRestrictionsInputAtom";
import {
  groupRestrictionsAtom,
  roundRestrictionsAtom,
} from "../../atoms/stores";

export const RestrictionsManager = () => {
  const { roundRestrictions, validateRestrictions, groupRestrictions } =
    useValidateBookingRules();

  const validateRestrictionsInput = useAtomValue(validateRestrictionsInputAtom);
  const setRoundRestrictions = useSetAtom(roundRestrictionsAtom);
  const setGroupRestrictions = useSetAtom(groupRestrictionsAtom);

  /**
   * When our inputs change, query for validation results.
   */
  useEffect(() => {
    if (!validateRestrictionsInput) return;
    validateRestrictions(validateRestrictionsInput);
  }, [validateRestrictions, validateRestrictionsInput]);

  /**
   * When we get new results, persist them to our atoms.
   */
  useEffect(() => {
    setRoundRestrictions(roundRestrictions ?? null);
    setGroupRestrictions(groupRestrictions ?? null);
  }, [
    groupRestrictions,
    roundRestrictions,
    setGroupRestrictions,
    setRoundRestrictions,
  ]);

  return null;
};
